import { render, staticRenderFns } from "./DraggerUpload.vue?vue&type=template&id=5ca34529&"
import script from "./DraggerUpload.vue?vue&type=script&lang=js&"
export * from "./DraggerUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports